export default "__VITE_ASSET__Tu3a_qUN__"